module.exports = flarum.core.compat['components/DiscussionListPane'];